import React from "react";
import AddUserForm from "./AddUserForm";
import Base from "../base";

import Swal from 'sweetalert2';

class App extends React.Component {
  // Base ref
  ref = null;

  state = {
    users: {}
  };


  componentDidMount() {

    this.ref = Base.syncState("/users", {
      context: this,
      state: "users"
    });

  }

  componentWillUnmount() {
    Base.removeBinding(this.ref);
  }

  addUser = (userData, form) => {
    this.userExists = false;
    const users = { ...this.state.users };
    const keys = Object.keys(users);
    for (const key of keys) {
      if (
        users[key].email === userData.email &&
        users[key].firstname === userData.firstname &&
        users[key].lastname === userData.lastname
      ) {
        this.userExists = true;
      }
    }
    if (!this.userExists) {
      users["primary"] = userData;
      this.setState({ users });
    }

    Swal.fire({
      title: this.userExists ? 'User Exits' : "Congrats! \n\r You\'ve created a new profile.",
      text: "Would you like to edit this user data?",
      type: this.userExists ? 'info' : "success",
      showCancelButton: true,
      confirmButtonColor: '#47a24a',
      cancelButtonColor: '#aa3243',
      confirmButtonText: 'Yes, edit it!',
      cancelButtonText: 'Nope, I\'m good',
    }).then((result) => {
      if (result.value) {
        this.props.history.push(`/edit`);
      }
    });

  };

  render() {
    return (
      <div>
        <h1>Create a User Profile</h1>
        <p>This is your public profile. Anyone using our App can see this.</p>
        <AddUserForm addUser={this.addUser} />
      </div>
    );
  }
}

export default App;
